// @ts-nocheck

import React, { useRef, useEffect, useCallback, useContext, useState } from 'react';

import ModalFixedContext from '../../contexts/ModalFixedContext';
import usePrevious from '../../hooks/usePrevious';

const ModalFixedContent = (props) => {
  const { render } = props;
  const mountedRef = useRef();
  const previousRender = usePrevious(render);
  const { setRenderer, updateRenderer, unsetRenderer } = useContext(ModalFixedContext);

  useEffect(() => {
    if (!mountedRef.current) {
      // componentDidMount
      mountedRef.current = true;
      setRenderer(render);
    } else {
      // componentDidUpdate
      if (render !== previousRender) {
        updateRenderer(render, previousRender);
      }
    }
  }, [render, setRenderer, updateRenderer, previousRender]);

  useEffect(
    () => {
      return () => {
        // cleanup is reloading everytime dependencies are reevaluated which is not the same behaviour as willUnmount
        // le cleanup se reload à chaque changement de dépendances et que cela pose problème car pas exactement identique au willUnmount.
        unsetRenderer(render);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  return null;
};

export const withFixedContent = (WrappedComponent) => {
  return function ModalFixed(props) {
    const renderers = useRef([]);
    const [, updateState] = useState();
    // We need to force an update, otherwise the renderers remain empty
    const forceUpdate = useCallback(() => updateState({}), []);
    const setRenderer = useCallback(
      (renderer) => {
        renderers.current.push(renderer);
        forceUpdate();
      },
      [renderers, forceUpdate],
    );
    const unsetRenderer = useCallback(() => {
      renderers.current = renderers.current.slice(0, -1);
      forceUpdate();
    }, [renderers, forceUpdate]);
    const updateRenderer = useCallback(
      (renderer, oldRenderer) => {
        unsetRenderer(oldRenderer);
        setRenderer(renderer);
        forceUpdate();
      },
      [setRenderer, unsetRenderer, forceUpdate],
    );
    return (
      <ModalFixedContext.Provider
        value={{
          setRenderer: setRenderer,
          updateRenderer: updateRenderer,
          unsetRenderer: unsetRenderer,
        }}
      >
        <WrappedComponent
          {...props}
          renderFixed={renderers.current.length ? renderers.current[renderers.current.length - 1] : null}
        />
      </ModalFixedContext.Provider>
    );
  };
};

export default ModalFixedContent;
